import * as React from 'react'
import { ReactElement } from 'react'
import { useFormikContext } from 'formik'
import { FileMutationDto } from '../../../config/fileConfig'
import { BudgetMonitoringModuleDto, useFileModule } from '../../../hooks/module/useFileModule'
import { ModuleType } from '../../../context/GlobalContext'
import { FieldProps } from '@fluentui/react-field'
import { Field, Switch, SwitchOnChangeData } from '@fluentui/react-components'
import FactorInput from './Insolvency/FactorInput'

type BudgetMonitoringFieldsProps = {
    styles: Record<'formRow', string>
    orientation: FieldProps['orientation']
}

export default function BudgetMonitoringFields({ styles, orientation }: BudgetMonitoringFieldsProps): ReactElement {
    const { values, setFieldValue } = useFormikContext<FileMutationDto>()
    const {
        has: hasFileModule,
        fileModule,
        index: fileModuleIndex,
    } = useFileModule<BudgetMonitoringModuleDto>(ModuleType.BudgetMonitoring, values)

    if (!hasFileModule) {
        return <></>
    }

    return (
        <div className={styles.formRow}>
            <Field label="Maximum aantal uren" orientation={orientation}>
                <FactorInput
                    required
                    step={1}
                    precision={1}
                    max={999}
                    value={`${fileModule.billableHours}`}
                    onChange={value => {
                        setFieldValue(`modules[${fileModuleIndex}.billableHours]`, value)
                    }}
                />
            </Field>
            <Field label="Inclusief aangeboden uren" orientation={orientation}>
                <Switch
                    label={fileModule.includeOfferedHours ? 'Ja' : 'Nee'}
                    labelPosition={'after'}
                    checked={fileModule.includeOfferedHours}
                    onChange={(_, data: SwitchOnChangeData) => {
                        fileModule.includeOfferedHours = data.checked
                        setFieldValue(`modules[${fileModuleIndex}.includeOfferedHours]`, data.checked)
                    }}
                />
            </Field>
            <Field label="Inclusief reeds gedeclareerde uren" orientation={orientation}>
                <Switch
                    label={fileModule.includeBilledHours ? 'Ja' : 'Nee'}
                    labelPosition={'after'}
                    checked={fileModule.includeBilledHours}
                    onChange={(_, data: SwitchOnChangeData) => {
                        fileModule.includeBilledHours = data.checked
                        setFieldValue(`modules[${fileModuleIndex}.includeBilledHours]`, data.checked)
                    }}
                />
            </Field>
        </div>
    )
}
